export default __webpack_public_path__ + "static/media/fan_2.bcb9d276.svg";